import styles from './booking.module.css';
import { useState, useEffect } from 'react';

const Step6 = () => {
  const [bookingSuccessData, setBookingSuccessData] = useState({});

  useEffect(() => {
    let bookingDataTemp = localStorage.getItem("bookingSuccessData");
    if (bookingDataTemp) {
      bookingDataTemp = JSON.parse(bookingDataTemp);
      setBookingSuccessData(bookingDataTemp);
    }
  }, []);

  return <>

    <div className={`${styles.BookingDone}`}>
      <img src="/images/check.png" alt="" />
      <p className={`${styles.BookingTitle}`}>Thank You!</p>
      <p className={`${styles.BookingSmTitle}`}>You successfully created your booking.</p>
      {(bookingSuccessData?.key_type === 'email') && <p className={`${styles.BookingSmTitle}`}>Email: <strong>{bookingSuccessData?.key_value}</strong></p>}
      {(bookingSuccessData?.key_type === 'phone') && <p className={`${styles.BookingSmTitle}`}>Phone: <strong>{bookingSuccessData?.key_value}</strong></p>}
      <p className={`${styles.BookingSmTitle}`}>Reference Id: <strong>{bookingSuccessData?.reference_id}</strong></p>
    </div>

  </>
}

export default Step6;